@if (!textOnly) {
  <div class="alert" [class]="alertClass" [innerHTML]="errorContent">
  </div>
} @else {
  <span [class]="alertClass" [innerHTML]="errorContent">
  </span>
}

<ng-template #lowBalance i18n="accelerator.low-balance">Your balance is too low.<br/>Please <a class="top-up-link" href="/services/accelerator/overview">top up your account</a>.</ng-template>
